/**
 * Layout backdrop component
 * 
 */

import React, { PureComponent } from 'react';

// Javascript

import DrawerJs from '../../../assets/js/drawer';

export default class Backdrop extends PureComponent {
	
	constructor(props) {

		super(props);
		
    	this.handleClick = this.handleClick.bind(this);
	}

	handleClick(event) {
		
		event.preventDefault();
				
		if (document.body.classList.contains('drawer-visible')) {

			const toggle = document.body.getAttribute('data-toggle');
			const panel = document.getElementById(toggle);
			
			DrawerJs.transition(panel, 'close');
		}
	}

	render() {
		
		return <div className="layout-backdrop" id="layout-backdrop" onClick={this.handleClick}></div>;
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/backdrop/backdrop.js